import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import {Typography} from 'antd';
import {PibisiStatus as Status} from 'api/generated';
import React from 'react';
import {Link} from 'react-router-dom';

type Props = {
  status: Status;
  accountId: string;
};

const {Text} = Typography;

export const PibisiStatus: React.FC<Props> = ({status, accountId}) => {
  const link = <Link to={`/accounts/${accountId}?tab=pibisi`}>(See report)</Link>;
  switch (status) {
    case Status.PENDING_TO_VERIFY:
      return (
        <>
          <Text type="warning" strong>
            <ExclamationCircleOutlined /> <span>Pending to verify</span>
          </Text>{' '}
          {link}
        </>
      );
    case Status.REJECTED:
      return (
        <>
          <Text type="danger" strong>
            <CloseCircleOutlined /> <span>Rejected</span>
          </Text>{' '}
          {link}
        </>
      );
    case Status.UNDER_REVIEW:
      return (
        <>
          <Text type="warning" strong>
            <ExclamationCircleOutlined /> <span>Under Review</span>
          </Text>{' '}
          {link}
        </>
      );
    case Status.VERIFIED:
      return (
        <Text type="success" strong>
          <CheckCircleOutlined /> <span>Verified</span>
        </Text>
      );
  }
};
